export const REPORT_LOADING = "REPORT_LOADING";
export const REPORT_RESET = "REPORT_RESET";
export const GET_REPORT = "GET_REPORT";
export const GET_REPORT_SUCCESS = "GET_REPORT_SUCCESS";
export const GET_REPORT_FAIL = "GET_REPORT_FAIL";